import { render, staticRenderFns } from "./Langs.vue?vue&type=template&id=0db05134&scoped=true"
import script from "./Langs.vue?vue&type=script&lang=js"
export * from "./Langs.vue?vue&type=script&lang=js"
import style0 from "./Langs.vue?vue&type=style&index=0&id=0db05134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db05134",
  null
  
)

export default component.exports